import { useI18n } from '#/i18n/hooks/useI18n';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import { useEmbedSearchWidget } from '#/modules/embedSearchWidget/contexts/EmbedSearchWidgetContext';
import { ActionDateRange } from '#/modules/search/components/Facet/ActionDateRange';
import { LocaleFacet } from '#/modules/search/components/Facet/LocaleFacet';
import { LocationTypeFacet } from '#/modules/search/components/Facet/LocationTypeFacet';
import { OrgAreasOfFocusFacet } from '#/modules/search/components/Facet/OrgAreasOfFocusFacet';
import { RecencyFacet } from '#/modules/search/components/Facet/RecencyFacet';
import { SearchRefinements } from '#/modules/search/components/Refinements/SearchRefinements';
import { DoneInADayFilter } from '#/modules/search/volops/components/DoneInADayFilter';
import { VolopKeywordsFacet } from '#/modules/search/volops/components/VolopKeywordsFacet';
import { VolopSourceFacet } from '#/modules/search/volops/components/VolopSourceFacet';
import { VolopWelcomeFacet } from '#/modules/search/volops/components/VolopWelcomeFacet';

type Props = {
  includeSourcesFacet: boolean;
};

export function SearchVolopsRefinements({ includeSourcesFacet }: Props) {
  const { locale } = useI18n();

  const { embedSearchWidget } = useEmbedSearchWidget();
  const excludedAreasOfFocus = embedSearchWidget
    ? embedSearchWidget.excludedAreasOfFocus
    : [];

  return (
    <SearchRefinements
      listingType="VOLOP"
      renderFacets={({ variant }) => {
        switch (locale) {
          case I18nLocale.EN:
            return (
              <>
                <LocationTypeFacet variant={variant} />
                <OrgAreasOfFocusFacet
                  variant={variant}
                  excludedAreasOfFocus={excludedAreasOfFocus}
                />
                <VolopWelcomeFacet variant={variant} />
                <DoneInADayFilter variant={variant} />
                {includeSourcesFacet && <VolopSourceFacet variant={variant} />}
                <ActionDateRange variant={variant} />
                <VolopKeywordsFacet variant={variant} />
                <LocaleFacet variant={variant} />
                <RecencyFacet variant={variant} />
              </>
            );

          case I18nLocale.ES:
            return (
              <>
                <LocaleFacet variant={variant} />
                <LocationTypeFacet variant={variant} />
                <OrgAreasOfFocusFacet
                  variant={variant}
                  excludedAreasOfFocus={excludedAreasOfFocus}
                />
                <VolopWelcomeFacet variant={variant} />
                <DoneInADayFilter variant={variant} />
                {includeSourcesFacet && <VolopSourceFacet variant={variant} />}
                <ActionDateRange variant={variant} />
                <VolopKeywordsFacet variant={variant} />
                <RecencyFacet variant={variant} />
              </>
            );

          case I18nLocale.PT:
            return (
              <>
                <LocaleFacet variant={variant} />
                <LocationTypeFacet variant={variant} />
                <OrgAreasOfFocusFacet
                  variant={variant}
                  excludedAreasOfFocus={excludedAreasOfFocus}
                />
                <VolopWelcomeFacet variant={variant} />
                <DoneInADayFilter variant={variant} />
                {includeSourcesFacet && <VolopSourceFacet variant={variant} />}
                <ActionDateRange variant={variant} />
                <VolopKeywordsFacet variant={variant} />
                <RecencyFacet variant={variant} />
              </>
            );
        }
      }}
    />
  );
}
